import {
  ADD_CUSTOMER_WAREHOUSE_FAIL,
  ADD_CUSTOMER_WAREHOUSE_REQUEST,
  ADD_CUSTOMER_WAREHOUSE_SUCCESS,
  DELETE_CUSTOMER_WAREHOUSE_FAIL,
  DELETE_CUSTOMER_WAREHOUSE_REQUEST,
  DELETE_CUSTOMER_WAREHOUSE_SUCCESS,
  GET_CUSTOMER_WAREHOUSE_LIST_REQUEST,
  GET_CUSTOMER_WAREHOUSE_LIST_FAIL,
  GET_CUSTOMER_WAREHOUSE_LIST_SUCCESS,
  GET_SINGLE_CUSTOMER_WAREHOUSE_FAIL,
  GET_SINGLE_CUSTOMER_WAREHOUSE_REQUEST,
  GET_SINGLE_CUSTOMER_WAREHOUSE_SUCCESS,
  UPDATE_CUSTOMER_WAREHOUSE_FAIL,
  UPDATE_CUSTOMER_WAREHOUSE_REQUEST,
  UPDATE_CUSTOMER_WAREHOUSE_SUCCESS,
} from "src/constants/types";

export const customerWarehouseReducers = (state = {}, actions) => {
  switch (actions.type) {
    case GET_CUSTOMER_WAREHOUSE_LIST_REQUEST:
      return {
        ...state,
        loading: true,
        error: "",
      };
    case GET_CUSTOMER_WAREHOUSE_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        customerWarehouses: actions.payload,
        error: "",
      };
    case GET_CUSTOMER_WAREHOUSE_LIST_FAIL:
      return {
        ...state,
        loading: false,
        error: actions.payload,
      };

    case DELETE_CUSTOMER_WAREHOUSE_REQUEST:
      return {
        ...state,
        loading: true,
        error: "",
      };
    case DELETE_CUSTOMER_WAREHOUSE_SUCCESS:
      return {
        ...state,
        loading: false,
        error: "",
      };
    case DELETE_CUSTOMER_WAREHOUSE_FAIL:
      return {
        ...state,
        loading: false,
        error: actions.payload,
      };

    case ADD_CUSTOMER_WAREHOUSE_REQUEST:
      return {
        ...state,
        loading: true,
        error: "",
      };
    case ADD_CUSTOMER_WAREHOUSE_SUCCESS:
      return {
        ...state,
        loading: false,
        error: "",
      };
    case ADD_CUSTOMER_WAREHOUSE_FAIL:
      return {
        ...state,
        loading: false,
        error: actions.payload,
      };

    case GET_SINGLE_CUSTOMER_WAREHOUSE_REQUEST:
      return {
        ...state,
        loading: true,
        error: "",
      };
    case GET_SINGLE_CUSTOMER_WAREHOUSE_SUCCESS:
      return {
        ...state,
        loading: false,
        customerWarehouse: actions.payload,
      };
    case GET_SINGLE_CUSTOMER_WAREHOUSE_FAIL:
      return {
        ...state,
        loading: false,
        error: actions.payload,
      };

    case UPDATE_CUSTOMER_WAREHOUSE_REQUEST:
      return {
        ...state,
        loading: true,
        error: "",
      };
    case UPDATE_CUSTOMER_WAREHOUSE_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case UPDATE_CUSTOMER_WAREHOUSE_FAIL:
      return {
        ...state,
        loading: false,
        error: actions.payload,
      };

    default:
      return state;
  }
};
